// extracted by mini-css-extract-plugin
export var count = "e_bF_fd";
export var statistic = "e_bF_fc";
export var statisticContainer = "e_bF_cw";